'use client';

import { type FC } from 'react';
import { cn, FloatingButton } from '@yanolja-rnd/nol-design-system';
import { IcMap } from '@yanolja-rnd/nol-icons';

export interface MapButtonProps {
  title: string;
  className?: string;
  hasGnb?: boolean;
  regionData?: string;
  onClick?: () => void;
}

export const MapButton: FC<MapButtonProps> = ({ title = '', className = '', onClick, hasGnb = false }) => {
  return (
    <div
      className={cn(
        'fixed bottom-16 left-1/2 flex -translate-x-1/2 justify-center pb-[env(safe-area-inset-bottom)] pc:bottom-24',
        hasGnb ? 'bottom-72' : 'bottom-16',
        className,
      )}>
      <FloatingButton
        buttonType="capsule"
        icon={<IcMap height={24} width={24} />}
        text={title}
        size={{ mobile: 'small', pc: 'medium' }}
        theme="outlined"
        onClick={onClick}
      />
    </div>
  );
};
